var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInSitu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_2128_521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7508 3.91614L10.145 0.028078C10.0514 -0.00976195 9.94858 -0.00888195 9.8567 0.027858C9.85605 0.028078 0.249161 3.91636 0.249161 3.91636C0.162019 3.95156 0.0925209 4.01646 0.0490576 4.09676L0.0469059 4.09764V4.10094C0.0167829 4.15836 0 4.22326 0 4.29102V17.709C0 17.8743 0.0987606 18.0228 0.248946 18.0837L9.85476 21.9718C9.90124 21.9907 9.95051 22.0001 9.99978 22.0001C10.0491 22.0001 10.0983 21.9907 10.1448 21.9718L19.7506 18.0837C19.901 18.0228 19.9996 17.8743 19.9996 17.709V4.2908C19.9996 4.12558 19.9008 3.97708 19.7506 3.91614H19.7508ZM0.886049 4.67712L9.60582 1.08892V11.1698L0.886049 14.6994V4.67712ZM10 18.7868L1.46484 15.3319L10 11.8771L18.5352 15.3319L10 18.7868Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInSitu);
export default __webpack_public_path__ + "static/media/in-situ.92f9fe941d08a785e3f894642c962d44.svg";
export { ForwardRef as ReactComponent };